import { render, staticRenderFns } from "./SessionExpire.vue?vue&type=template&id=009989aa&scoped=true&"
import script from "./SessionExpire.vue?vue&type=script&lang=js&"
export * from "./SessionExpire.vue?vue&type=script&lang=js&"
import style0 from "./SessionExpire.vue?vue&type=style&index=0&id=009989aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009989aa",
  null
  
)

export default component.exports